import React from "react"
import Injury from "./Injury"
import "./Section.03.Injury.css"


export default function InjurySection(params) {

    const {rescue, values} = params
    
    const setInjury = (id, injury) => {
        const injuries = [...rescue.rescue?.injuries ?? []]
        injuries[id] = injury
        rescue.setField("injuries", injuries)
    }

    
    const addInjury = () => {
        if (!rescue) return
        const injuries = [...rescue.rescue?.injuries ?? []]
        injuries.push({image_id: 0})
        rescue.setField("injuries", injuries)
    }
    
    const removeInjury = (id) => {
        const injuries = [...rescue.rescue?.injuries ?? []]
        injuries.splice(id, 1); 
        rescue.setField("injuries", injuries)
    }
    
    return <li className="accordion" id="accordion-injury">
        <input type="checkbox" className="accordion" name="accordion" id="acc-injury"/>
        <label className="accordion" htmlFor="acc-injury">Povrede</label>
        <section className="accordion">
            {!!rescue.rescue?.injuries && <div id="injuries">
                {rescue.rescue.injuries.map((injury, index) => <Injury key={index} rescue={rescue} id={index} injury={injury} values={values} setInjury={setInjury} removeInjury={removeInjury}/>)}
            </div>}
            {!rescue.isReadOnly&& <div id="injuries-buttons">
                <button className="add-injury btn btn-primary" onClick={addInjury}><i className="fas fa-plus"/>&nbsp;&nbsp;Dodaj povredu</button>
            </div>}
        </section>
    </li>
    
}